import React, { useState } from 'react'
import moment from 'moment'
import { cancelAppointment } from '../utils/appointmentAPI'

// Merged replacement for PickupStatus + DeliveryStatus.
// Uses an inline confirmation instead of a react-bootstrap Modal.
const StatusBadge = ({ type, existingAppts, required, locationInfo, reload, isBeingScheduled }) => {
    const [confirmCancel, setConfirmCancel] = useState(false)
    const [cancelling, setCancelling] = useState(false)

    if (isBeingScheduled) {
        return (
            <div className="alert alert-secondary border-dark mt-2 d-flex align-items-center gap-2" role="alert">
                <strong>Updating...</strong>
                <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            </div>
        )
    }

    const handleCancel = async (appointment) => {
        setCancelling(true)
        await cancelAppointment({ appointment, locationId: locationInfo?.dockLocationId })
        setCancelling(false)
        setConfirmCancel(false)
        reload()
    }

    if (existingAppts && existingAppts.length) {
        return existingAppts.map((event, index) => (
            <div className="alert alert-success mt-2 border border-success d-inline-block w-50" role="alert" key={index}>
                <div>Scheduled {type} Appt:</div>
                <strong>{moment(event.StartTime).format('MMMM D')}</strong><br />
                <strong>{moment(event.StartTime).format('h:mm a')}</strong>
                {' '}to{' '}
                <strong>{moment(event.EndTime).format('h:mm a')}</strong>

                {confirmCancel ? (
                    <div className="mt-2 border-top pt-2">
                        <p className="mb-2 small">Cancel this appointment?</p>
                        <button
                            className="btn btn-danger btn-sm me-2"
                            onClick={() => handleCancel(event)}
                            disabled={cancelling}
                        >
                            {cancelling ? 'Cancelling...' : 'Yes, Cancel'}
                        </button>
                        <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => setConfirmCancel(false)}
                            disabled={cancelling}
                        >
                            Keep It
                        </button>
                    </div>
                ) : (
                    <div className="d-flex justify-content-center mt-3">
                        <button
                            className="btn btn-light btn-sm border border-danger text-danger"
                            onClick={() => setConfirmCancel(true)}
                        >
                            Cancel Appointment
                        </button>
                    </div>
                )}
            </div>
        ))
    }

    if (required) {
        return (
            <div className="small text-warning-emphasis mt-1 mb-1">
                ⚠️ Appointment required
            </div>
        )
    }

    return (
        <div className="small text-muted mt-1 mb-1">
            No {type.toLowerCase()} appointment required.
        </div>
    )
}

export default StatusBadge
